import React from 'react';
import { useSelector } from 'react-redux';
import { SRow, SCol } from '@avalara/skylab-sdk/react';
import styled from 'styled-components';
import { selectState } from '../../../selectors';
import DatesToRemember from './dates-to-remember';
import BillingSummary from './billing-summary';
import CamPanel from './cam-panel';
const Wrapper = styled.div `
  margin: 50px 0;
`;
const BottomContent = () => {
    const { account: { camOwned, cam } } = useSelector(selectState);
    const camPanel = (!!camOwned && !!cam &&
        React.createElement(CamPanel, { name: cam.name, email: cam.email, phone: cam.phone, photoUrl: cam.photoUrl }));
    return (React.createElement(Wrapper, null,
        React.createElement(SRow, { className: 'justify-content-center' },
            React.createElement(SCol, { span: 'md-12 lg-4 xl-3 4' },
                React.createElement(DatesToRemember, null)),
            React.createElement(SCol, { span: 'md-12 lg-2 xl-2 2' },
                React.createElement(BillingSummary, null)),
            camPanel &&
                React.createElement(SCol, { span: 'md-12 lg-2 2' }, camPanel))));
};
export default BottomContent;
